//#region  imports
import { Injectable } from '@angular/core';
import { SimulationReservationReason } from '../module/recapitulatory/model/recapitulatory.model';
import { mobileProgressBarModel, ProgressBarModel } from '../shared/model/progressbar.model';
import { ProgressBarService } from './progressbar.service';
import { Subject, Observable } from 'rxjs';
//#endregion

@Injectable({
  providedIn: 'root'
})
export class P5xService {
  //#region variables
  isP5XPage = false;
  disableP5XPrevious = new Subject<boolean>();
  isOwner = false;
  p215AcceptanceCriteria = false;
  p215GridCriteriaChecked = false;
  p225AcceptanceCriteria = false;
  p225GridCriteriaChecked = false;
  p225Checked = false;
  p216CapitalGreaterThanMax = false;
  p226CapitalGreaterThanMax = false;
  isTakerOther = false;
  isPropertyOther = false;
  secondaryResidence = false;
  theftChecked = false;
  p223IndoorPoolChecked = false;
  p41TheftChecked = false;
  rsrStatus = false;
  documentStatus = false;
  documentGenerateStatus = false;
  contentCapital = false;
  simulationReservationReason: SimulationReservationReason;
  //#endregion

  //#region methods
  constructor(private progressBarService: ProgressBarService) { }

  setIsP5XPage(value: boolean) {
    this.isP5XPage = value;
  }

  getIsP5XPage(): boolean {
    return this.isP5XPage;
  }

  setDisableP5XPrevious(value: boolean) {
    this.disableP5XPrevious.next(value);
  }

  getDisableP5XPrevious(): Observable<boolean> {
    return this.disableP5XPrevious.asObservable();
  }

  setP215AcceptanceCriteria(value: boolean) {
    this.p215AcceptanceCriteria = value;
  }

  getP215AcceptanceCriteria(): boolean {
    return this.p215AcceptanceCriteria;
  }

  setP215GridCriteriaChecked(value: boolean) {
    this.p215GridCriteriaChecked = value;
  }

  getP215GridCriteriaChecked(): boolean {
    return this.p215GridCriteriaChecked;
  }

  setP223IndoorPoolChecked(value: boolean) {
    this.p223IndoorPoolChecked = value;
  }

  getP223IndoorPoolChecked(): boolean {
    return this.p223IndoorPoolChecked;
  }

  setP225AcceptanceCriteria(value: boolean) {
    this.p225AcceptanceCriteria = value;
  }

  getP225AcceptanceCriteria(): boolean {
    return this.p225AcceptanceCriteria;
  }

  setP225GridCriteriaChecked(value: boolean) {
    this.p225GridCriteriaChecked = value;
  }

  getP225GridCriteriaChecked(): boolean {
    return this.p225GridCriteriaChecked;
  }

  setP216CapitalGreaterThanMax(value: boolean) {
    this.p216CapitalGreaterThanMax = value;
  }

  getP216CapitalGreaterThanMax(): boolean {
    return this.p216CapitalGreaterThanMax;
  }

  setP226CapitalGreaterThanMax(value: boolean) {
    this.p226CapitalGreaterThanMax = value;
  }

  getP226CapitalGreaterThanMax(): boolean {
    return this.p226CapitalGreaterThanMax;
  }

  setIsOwner(value: boolean) {
    this.isOwner = value;
  }

  getIsOwner(): boolean {
    return this.isOwner;
  }

  setIsPropertyOther(value: boolean) {
    this.isPropertyOther = value;
  }

  getIsPropertyOther(): boolean {
    return this.isPropertyOther;
  }

  setIsTakerOther(value: boolean) {
    this.isTakerOther = value;
  }

  getIsTakerOther(): boolean {
    return this.isTakerOther;
  }

  setSecondaryResidence(value: boolean) {
    this.secondaryResidence = value;
  }

  setContentCapital(value: boolean) {
    this.contentCapital = value;
  }

  getContentCapital(): boolean {
    return this.contentCapital;
  }

  getSecondaryResidence(): boolean {
    return this.secondaryResidence;
  }

  setTheftChecked(value: boolean) {
    this.theftChecked = value;
  }

  getTheftChecked(): boolean {
    return this.theftChecked;
  }

  setP41TheftChecked(value: boolean) {
    this.p41TheftChecked = value;
  }

  getP41TheftChecked(): boolean {
    return this.p41TheftChecked;
  }

  setRSRStatus(value: boolean) {
    this.rsrStatus = value;
  }

  getRSRStatus(): boolean {
    return this.rsrStatus;
  }

  setDocumentStatus(value: boolean) {
    this.documentStatus = value;
  }

  getDocumentStatus(): boolean {
    return this.documentStatus;
  }

  setDocumentGenerateStatus(value: boolean) {
    this.documentGenerateStatus = value;
  }

  getDocumentGenerateStatus(): boolean {
    return this.documentGenerateStatus;
  }

  setSimulationReservationReason(value: SimulationReservationReason) {
    this.simulationReservationReason = value;
  }

  getSimulationReservationReason(): SimulationReservationReason {
    return this.simulationReservationReason;
  }

  // setSimulationReservationReason(value: SimulationReservationReason) {
  //   if (!this.simulationReservationReason.find(obj => obj.ID === value.ID)) {
  //     this.simulationReservationReason.push(value);
  //   }
  // }

  // removeSimulationReservationReason(id: number) {
  //   const reasonArray = this.simulationReservationReason.filter(obj => obj.ID !== id);
  //   this.simulationReservationReason = reasonArray;
  // }

  setP5XProgressBarDetails() {
    const characteristicsProgressStatus: ProgressBarModel = {
      Disable: true, Number: true, Icon: true
    };
    const detailsProgressStatus: ProgressBarModel = {
      Disable: true, Number: true, Icon: true
    };
    const guaranteeProgressStatus: ProgressBarModel = {
      Disable: true, Number: true, Icon: true
    };
    const summaryProgressStatus: ProgressBarModel = {
      Disable: true, Number: true, Icon: false
    };
    const signatureProgressStatus: ProgressBarModel = {
      Disable: true, Number: true, Icon: false
    };
    this.progressBarService.setCharacteristicsProgressStatus(characteristicsProgressStatus);
    this.progressBarService.setDetailsProgressStatus(detailsProgressStatus);
    this.progressBarService.setGauranteeProgressStatus(guaranteeProgressStatus);
    this.progressBarService.setSummaryProgressStatus(summaryProgressStatus);
    this.progressBarService.setSignatureProgressStatus(signatureProgressStatus);
  }

  setmobileP5XProgressBarDetails() {
    const characteristicsProgressStatus: mobileProgressBarModel = {
      Enable: false
    };
    const detailsProgressStatus: mobileProgressBarModel = {
      Enable: false
    };
    const guaranteeProgressStatus: mobileProgressBarModel = {
      Enable: false
    };
    const summaryProgressStatus: mobileProgressBarModel = {
      Enable: true
    };
    const signatureProgressStatus: mobileProgressBarModel = {
      Enable: false
    };
    this.progressBarService.setmobileCharacteristicsProgressStatus(characteristicsProgressStatus);
    this.progressBarService.setmobileDetailsProgressStatus(detailsProgressStatus);
    this.progressBarService.setmobileGauranteeProgressStatus(guaranteeProgressStatus);
    this.progressBarService.setmobileSummaryProgressStatus(summaryProgressStatus);
    this.progressBarService.setmobileSignatureProgressStatus(signatureProgressStatus);
    if (document.getElementById("tab1") !== null && document.getElementById("tab1") !== undefined 
    && document.getElementById("tab2") !== null && document.getElementById("tab2") !== undefined
    && document.getElementById("tab3") !== null && document.getElementById("tab3") !== undefined
    && document.getElementById("tab4") !== null && document.getElementById("tab4") !== undefined
    && document.getElementById("tab5") !== null && document.getElementById("tab5") !== undefined ){
    document.getElementById("tab1").classList.add("d-none");
    document.getElementById("tab2").classList.add("d-none");
    document.getElementById("tab3").classList.add("d-none");
    document.getElementById("tab5").classList.add("d-none");
    document.getElementById("tab4").classList.remove("disabledSection");
    document.getElementById("tab4").querySelector(".panel-heading").classList.add("d-none");
    }
  }
  //#endregion
}
